'use client';

import styled from 'styled-components';
import { COLORS } from '@/constants';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const InfoContainer = styled.div`
  * {
    font-family: "Plus Jakarta Sans", sans-serif !important;
  }
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoTitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 155%;
  color: ${COLORS['black']};
`;


